module.exports = __webpack_public_path__ + "static/media/icon_biaozhunhua.628e1fb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_biaozhunhua.svg
// module id = 128
// module chunks = 0